import React, { useCallback, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';

import { forgotPassword, login as loginApi } from '../libs/api';
import { useAuth } from '../hooks/useAuth';

function Login() {
  const [emailOrPhone, setEmailOrPhone] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [isPhone, setIsPhone] = React.useState(false);
  const { login, currentUser } = useAuth();
  const navigate = useNavigate();

  const onClickSubmit = useCallback(async (e) => {
    e.preventDefault();
    if (isPhone) {
      const { ok, data } = await forgotPassword(emailOrPhone);
      if (ok) {
        toast.success('Text message sent.');
        setIsPhone(false);
        setEmailOrPhone('');
      } else {
        toast.error(`Unable to send text message. ${data && data.message ? `\n${data.message}` : ''}`);
      }
      return;
    }
    const res = await loginApi(emailOrPhone, password);
    if (res.ok) {
      login(res.data);
    } else {
      // eslint-disable-next-line max-len
      toast.error('Sorry, your login information was incorrect. Please double-check your information or click Forgot Password to reset your password.');
    }
  }, [emailOrPhone, password]);

  useEffect(() => {
    if (emailOrPhone) {
      const isDigits = /^\+?\d{3,12}$/.test(emailOrPhone);
      setIsPhone(isDigits);
    }
  }, [emailOrPhone]);

  useEffect(() => {
    if (currentUser) {
      navigate('/');
    }
  }, [currentUser]);

  return (
    <div>
      <div className="auth-wrapper">
        <h1 className="h2">Login</h1>
        <form className="auth-form">
          <div className="form-field">
            <label htmlFor="auth-email">
              <div>Email or Phone Number</div>
              <input
                type="email"
                autoComplete="username"
                id="auth-email"
                value={emailOrPhone}
                onChange={(e) => setEmailOrPhone(e.target.value)}
              />
            </label>
          </div>
          <div className={`auth-msg ${!isPhone ? 'hide' : ''}`}>
            <h4>Spokenote now uses an email and password combination to log in</h4>
            <hr />
            <p>
              <strong>How to Set An Email & Password</strong>
              <br />
              Enter your phone number above and click &quot;Send Link to Set Password.&quot;
              We will send a text message to your phone number so that you securely update your account.
            </p>
            <p>
              <strong>If You&apos;ve Already Set an Email & Password</strong>

              <br />
              Enter your email above instead of your phone number.
            </p>
          </div>
          {!isPhone && (
            <>
              <div className="form-field">
                <label htmlFor="auth-password">
                  <div>Password</div>
                  <input
                    type="password"
                    autoComplete="current-password"
                    id="auth-password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </label>
              </div>

              <div className="form-field forgot-password-field">
                <Link to="/forgot-password">Forgot Password?</Link>
              </div>
            </>
          )}
          <div className="form-field">
            <input
              type="submit"
              value={isPhone ? 'Send Link to Set Password' : 'Log In'}
              className="mb-0"
              onClick={onClickSubmit}
            />
          </div>
        </form>
        <div className="alt-auth">
          Need an account?
          &nbsp;
          <Link to="/signup">
            Sign Up
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Login;
